import {CALL_API} from 'redux-api-middleware';
import {ENDPOINT_DISASTER} from 'common/endpoints';
import _ from 'lodash';
import {
  API_COMMENT_GET_REQUEST,
  API_COMMENT_GET_SUCCESS,
  API_COMMENT_GET_FAILURE,
} from 'common/types';

import {commonJwtHeader} from 'common/utils';

export default {
  getAllDisasterAreas: (token, disasterId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DISASTER}declarations/${disasterId}/designated-area`,
        method: 'GET',
        headers: commonJwtHeader(),
        types: [
          API_COMMENT_GET_REQUEST,
          API_COMMENT_GET_SUCCESS,
          API_COMMENT_GET_FAILURE,
        ],
      },
    };
  },
};
